import React, {forwardRef} from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';

type Props = {
    children: React.ReactNode;
    onClick: () => void;
    isFocused?: boolean;
    isActive?: boolean;
    itemBorder?: boolean;
    componentClasses?: string;
};

export const DropdownBaseItem = forwardRef<HTMLDivElement, Props>((props, ref) => {
    const {children, isFocused, itemBorder, componentClasses, isActive, onClick} = props;

    return (
        <div
            ref={ref}
            className={cx(styles.item, componentClasses, {
                [styles.focused]: isFocused,
                [styles.active]: isActive,
                [styles.itemBorder]: itemBorder
            })}
            onClick={onClick}
        >
            {children}
        </div>
    );
});
